import { gql } from '@apollo/client';

export const UPDATE_USER_MUTATION = gql`
    mutation updateUser($input: UpdateUserInput) {
        updateUser(input: $input) {
            newUser
            interests
            lastActive
            id
            avatar
            bio
            companyName
            country
            zipPostalCode
            email
            firstName
            jobTitle
            lastName
            phoneNumber
            username
            role
        }
    }
`;
